export const homePageDataObj = {
    headerLeft : {
        a: {
            header: "Hassle Free Job Search",
            subheader: "Streamlined search experience tailored to your skill set."
        },
        b: {
            header: "Simplified and Focused Profiles",
            subheader: "Clear and concise profiles to showcase your expertise."
        },
        c: {
            header: "One-Click Apply",
            subheader: "Effortlessly apply to opportunities with just a click."
        },
        d: {
            header: "Track Your Applications",
            subheader: "Easily monitor the status of your job applications in one place."
        }
    },
    headerRight : {
        header: "Land Your First Tech Opportunity With inIT!",
        subheader: "Whether you are an entry-level engineer looking to jump start your career in tech, or a recruiter looking to fill entry-level positions at a company, inIT is here to connect you!"
    }
}